import React from 'react'

export default function NotFoundPage() {
    return (
        <div>
            Không tìm thấy địa chỉ tìm kiếm của bạn
        </div>
    )
}
